{
  "allWeb3Coins": "تمام Web3 کوائنز",
  "approvalPending": "اپروول جاری ہے...",
  "assets": "اثاثے",
  "bnbBalance": "BNB بیلنس",
  "bnbSendFailed": "BNB بھیجنے میں ناکامی",
  "bnbSentSuccessfully": "BNB کامیابی سے بھیج دیا گیا",
  "clearHistory": "ہسٹری صاف کریں",
  "clearHistoryConfirm": "کیا آپ واقعی تمام ٹرانزیکشن ہسٹری حذف کرنا چاہتے ہیں؟",
  "connectWallet": "والیٹ کنیکٹ کریں",
  "connectWalletFirst": "پہلے والٹ کنیکٹ کریں",
  "connectWeb3Wallet": "ویب3 والٹ کنیکٹ کریں",
  "copyAddressReceive": "ایڈریس کاپی کریں / وصول کریں",
  "disconnect": "ڈس کنیکٹ",
  "enterAmount": "رقم درج کریں",
  "fromCoin": "From Coin",
  "history": "ہسٹری",
  "installWallet": "براہ کرم MetaMask یا Trust Wallet انسٹال کریں۔",
  "insufficientBnbGas": "BNB ناکافی ہے۔ گیس فیس کے لیے کم از کم 0.01 BNB رکھیں۔",
  "loading": "لوڈ ہو رہا ہے...",
  "noNewReceiveTransaction": "کوئی نئی ریسیو ٹرانزیکشن نہیں ملی",
  "noTransactionsYet": "ابھی کوئی ٹرانزیکشن نہیں",
  "processing": "پروسیسنگ ہو رہی ہے...",
  "receive": "وصول کریں",
  "receiveCrypto": "کرپٹو وصول کریں",
  "receiveTransactionSynced": "ریسیو ٹرانزیکشن ہم آہنگ ہوگئی",
  "receiverAddress": "ریسیور ایڈریس",
  "refreshBalance": "بیلنس ریفریش کریں",
  "searchCoin": "کوائن تلاش کریں...",
  "searchTransaction": "ٹرانزیکشن تلاش کریں...",
  "send": "بھیجیں",
  "sendNow": "ابھی بھیجیں",
  "serverError": "سرور میں خرابی۔",
  "sessionExpired": "سیشن ختم ہو گیا۔ براہ کرم دوبارہ لاگ ان کریں۔",
  "swap": "سواپ",
  "swapCompleted": "سواپ مکمل ہوگیا",
  "swapFailed": "سواپ ناکام ہوگیا",
  "swapNow": "ابھی سواپ کریں",
  "swapPending": "سواپ جاری ہے...",
  "swapTrade": "سواپ / ٹریڈ",
  "syncHistory": "ہسٹری سنک کریں",
  "syncReceive": "ریسیو سنک کریں",
  "toCoin": "To Coin",
  "tokenSwapRouteSoon": "ٹوکن سے ٹوکن سواپ جلد شامل کیا جائے گا",
  "totalAssets": "کل اثاثے",
  "transactionConfirmed": "ٹرانزیکشن کامیاب ہوگئی",
  "transactionHistory": "ٹرانزیکشن ہسٹری",
  "transactionPending": "ٹرانزیکشن جاری ہے...",
  "viewOnBscScan": "BscScan پر دیکھیں",
  "walletAddress": "والٹ ایڈریس",
  "walletAddressCopied": "والٹ ایڈریس کاپی ہو گیا",
  "walletAppNotFound": "MetaMask / Trust Wallet نہیں ملا",
  "walletConnected": "والیٹ کامیابی سے منسلک ہوگیا۔",
  "walletConnectionFailed": "والٹ کنیکٹ نہیں ہو سکا",
  "walletDisconnected": "والٹ منقطع ہو گیا",
  "walletNotFound": "والٹ نہیں ملا",
  "web3Wallet": "ایگزالٹ ایکسچینج ویب3 والٹ",
  "web3WalletSubtitle": "محفوظ MetaMask / Trust Wallet • BNB Smart Chain • EXALT Wallet"
}